(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["giveaway-agreement"] && !Shopify.designMode) return;
  try {
    function initializeGiveawayAgreement() {
    var container = document.querySelector('[data-giveaway-agreement-container]');

    if (!container || container.dataset.initialized === 'true') {
      return;
    }

    var checkboxes = container.querySelectorAll('[data-required-cart-agreement]');
    var form = container.closest('form');

    if (!form || checkboxes.length === 0) {
      return;
    }

    var checkoutButton = form.querySelector('button[name="checkout"]');

    if (!checkoutButton) {
      return;
    }

    function allAgreementsChecked() {
      return Array.prototype.every.call(checkboxes, function(checkbox) {
        return checkbox.checked;
      });
    }

    function updateCheckoutButton() {
      var allChecked = allAgreementsChecked();
      checkoutButton.disabled = !allChecked;
      checkoutButton.setAttribute('aria-disabled', allChecked ? 'false' : 'true');
    }

    container.dataset.initialized = 'true';
    Array.prototype.forEach.call(checkboxes, function(checkbox) {
      checkbox.addEventListener('change', updateCheckoutButton);
    });
    form.addEventListener('submit', function(event) {
      if (event.submitter && event.submitter.name === 'checkout' && !allAgreementsChecked()) {
        event.preventDefault();
        var firstUnchecked = container.querySelector('[data-required-cart-agreement]:not(:checked)');

        if (firstUnchecked) {
          firstUnchecked.focus();
        }
      }
    });
    updateCheckoutButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGiveawayAgreement);
  } else {
    initializeGiveawayAgreement();
  }

  document.addEventListener('shopify:section:load', initializeGiveawayAgreement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pup-offroad-design-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = root => {
      root.querySelectorAll('[data-pup-picker]').forEach(picker => {
        if (picker.dataset.initialized) return;
        const form = picker.closest('form');
        const radios = Array.from(picker.querySelectorAll('input[name="properties[Design]"]'));
        if (!form || !radios.length) return;
        picker.dataset.initialized = 'true';
        const error = picker.querySelector('.pup-picker__error');
        const status = picker.querySelector('[data-pup-status]');
        const showError = () => {
          error.hidden = false;
          picker.classList.add('pup-picker--error');
          radios.forEach(radio => radio.setAttribute('aria-invalid', 'true'));
        };
        radios.forEach(radio => {
          radio.addEventListener('invalid', showError);
          radio.addEventListener('change', () => {
            error.hidden = true;
            picker.classList.remove('pup-picker--error');
            radios.forEach(input => input.removeAttribute('aria-invalid'));
            status.textContent = radio.dataset.selectedMessage;
          });
        });
        form.addEventListener('submit', event => {
          if (!radios.some(radio => radio.checked)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showError();
            radios[0].focus();
          }
        }, true);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["youth-vibes-design-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = root => {
      root.querySelectorAll('[data-yv-picker]').forEach(picker => {
        if (picker.dataset.initialized) return;
        const form = picker.closest('form');
        const radios = Array.from(picker.querySelectorAll('input[name="properties[Design]"]'));
        if (!form || !radios.length) return;
        picker.dataset.initialized = 'true';
        const error = picker.querySelector('.yv-picker__error');
        const status = picker.querySelector('[data-yv-status]');
        const showError = () => {
          error.hidden = false;
          picker.classList.add('yv-picker--error');
          radios.forEach(radio => radio.setAttribute('aria-invalid', 'true'));
        };
        radios.forEach(radio => {
          radio.addEventListener('invalid', showError);
          radio.addEventListener('change', () => {
            error.hidden = true;
            picker.classList.remove('yv-picker--error');
            radios.forEach(input => input.removeAttribute('aria-invalid'));
            status.textContent = radio.dataset.selectedMessage;
          });
        });
        form.addEventListener('submit', event => {
          if (!radios.some(radio => radio.checked)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showError();
            radios[0].focus();
          }
        }, true);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
